import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import programImg from "../../assets/info_img.avif";
import programImg1 from "../../assets/cybersecurity solutions.jpeg";
import programImg2 from "../../assets/program-img2.jpg";
import programImg3 from "../../assets/program-img3.jpg";

const defaultPrograms = [
  {
    id: 1,
    image: programImg,
    heading: "Information Technology",
    introduction: "Build core IT skills from fundamentals to diploma level.",
    buttonText: "View Certifications",
    certifications: [
      "Basic Technician Certificate in IT first year",
      "Technician in Information Technology second year",
      "Diploma in Information Technology third year",
    ],
  },
  {
    id: 2,
    image: programImg1,
    heading: "Cybersecurity",
    introduction: "Learn to protect systems, data, and networks from threats.",
    buttonText: "View Certifications",
    certifications: [
      "Basic Technician Certificate in Cybersecurity",
      "Technician in Cybersecurity",
      "Diploma in Cybersecurity",
    ],
  },
  {
    id: 3,
    image:
      "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=2072&q=80",
    heading: "Business Administration",
    introduction: "Develop business, management, and leadership capabilities.",
    buttonText: "View Certifications",
    certifications: [
      "Basic Technician Certificate in Business Administration",
      "Technician in Business Administration",
      "Diploma in Business Administration",
    ],
  },
  {
    id: 4,
    image:
      "https://images.unsplash.com/photo-1488646953014-85cb44e25828?auto=format&fit=crop&w=2072&q=80",
    heading: "Travel and Tourism",
    introduction: "Gain expertise in travel operations and tourism services.",
    buttonText: "View Certifications",
    certifications: [
      "Basic Technician Certificate in Travel and Tourism",
      "Technician in Travel and Tourism",
      "Diploma in Travel and Tourism",
    ],
  },
];

const ProgramCards = ({
  programs = defaultPrograms,
  basePath = "/course",
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [expandedCardId, setExpandedCardId] = useState(null);
  const navigate = useNavigate();

  // Map program headings to actual routes defined in App.js
  const headingToRoute = {
    "Information Technology": "/course/information-technology",
    "Cybersecurity": "/course/cyber-security",
    "Business Administration": "/course/business-administration",
    "Travel and Tourism": "/course/travel-tourism-management",
  };

  useEffect(() => {
    // Trigger animation after component mounts
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  const toggleExpand = (programId) => {
    setExpandedCardId((prev) => (prev === programId ? null : programId));
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mt-8 mb-32 justify-center items-start">
      {programs.map((program, index) => {
        const isExpanded = expandedCardId === program.id;
        const controlsId = `certifications-${program.id}`;
        return (
          <div
            key={program.id}
            className={`
            border rounded-xl overflow-hidden shadow-lg w-full mx-auto max-w-[340px]
            transform transition-all duration-700 ease-out bg-white
            hover:shadow-2xl hover:-translate-y-3 hover:scale-[1.02]
            group
            ${
              isVisible
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-8"
            }
          `}
            style={{
              transitionDelay: `${index * 150}ms`,
            }}
          >
            <div className="relative overflow-hidden">
              <img
                src={program.image}
                alt={program.heading}
                className="w-full h-[220px] object-cover transition-transform duration-500 ease-out group-hover:scale-110"
              />
              <span className="block border-b-4 border-gold w-full transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 ease-out origin-left"></span>
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-all duration-300 ease-out"></div>
            </div>
            <div className="p-6 text-left">
              <h3 className="font-bold text-[1.25rem] mb-2 text-custom-pink tracking-normal">
                {program.heading}
              </h3>
              <p className="mb-4 text-[0.95rem] text-gray-800">
                {program.introduction}
              </p>
              <div className="flex items-center gap-3">
                <button
                  onClick={() => toggleExpand(program.id)}
                  aria-expanded={isExpanded}
                  aria-controls={controlsId}
                  className={`
                    bg-custom-pink text-xs sm:text-sm text-white px-3 sm:px-5 py-2 rounded-full
                    transition-all duration-300 ease-out
                    hover:bg-white hover:text-custom-pink hover:border hover:border-custom-pink
                    focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-custom-pink
                    hover:scale-105 hover:shadow-lg
                  `}
                >
                  {isExpanded ? "Hide Certifications" : program.buttonText}
                </button>
                <button
                  onClick={() => {
                    const slug = program.heading
                      .toLowerCase()
                      .replace(/[^a-z0-9]+/g, "-")
                      .replace(/(^-|-$)/g, "");
                    const target = headingToRoute[program.heading] || `${basePath}/${slug}`;
                    navigate(target);
                  }}
                  className="text-xs sm:text-sm px-3 sm:px-4 py-2 rounded-full border border-gray-300 text-gray-700 hover:border-gold hover:text-gold transition-colors"
                >
                  Learn More
                </button>
              </div>

              <div
                id={controlsId}
                role="region"
                aria-label={`${program.heading} certifications`}
                className={`overflow-hidden transition-[max-height,opacity] duration-500 ease-in-out ${
                  isExpanded ? "max-h-80 opacity-100 mt-4" : "max-h-0 opacity-0"
                }`}
              >
                <ul className="list-disc pl-5 space-y-2 text-gray-800">
                  {program.certifications?.map((cert, idx) => (
                    <li key={idx} className="leading-relaxed">
                      {cert}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ProgramCards;
